export const VAST_XML = 'VastXML';
export const VAST_TAG = 'VastTag';
